import { TranslatedText } from '../Translation';

export interface Page {
  id: number;
  name: string;
  nameTranslation: TranslatedText;
  slug: string;
  body: string;
  bodyTranslation: TranslatedText;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyPage = (): Page => ({
  id: 0,
  name: '',
  nameTranslation: {},
  slug: '',
  body: '',
  bodyTranslation: {},
  isActive: false,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const pageFromResponse = (responseData: any): Page => ({
  id: responseData.id,
  name: responseData.name,
  nameTranslation: responseData.name_translation ?? {},
  slug: responseData.slug,
  body: responseData.body,
  bodyTranslation: responseData.body_translation ?? {},
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const pageToUpsertRequest = (page: Page) => ({
  name: page.name,
  name_translation: page.nameTranslation,
  body: page.body,
  body_translation: page.bodyTranslation,
  is_active: page.isActive,
});
